// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderSignButton_button__2TnlL"};